export const TYPE = {
  aSESH: 'aSESH',
  eSESH: 'eSESH',
};

export const SWAP_TYPE = {
  OXEN_TO_aSESH: 'oxen_to_eth',
  WOXEN_TO_eSESH: 'eth_to_oxen',
};
